module.exports = [{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../node_modules/.pnpm/gatsby@5.15.0_@swc+core@1.12.9_@swc+helpers@0.5.15__babel-eslint@10.1.0_eslint@7.32.0__eslint_hkod45cwa7hppyyfxpjh6fxfvi/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
